const setPublicationLinks = (publication,widget) => {
  const links = widget.querySelectorAll('.c-editorial-feed__link');
  const btns = widget.querySelectorAll('.c-editorial-feed__btn');

  if(links && btns) {
    links.forEach(link => {
        link.href = publication.file.url;
        link.innerText = publication.file.title;
    });

    btns.forEach(btn => {
      btn.href = publication.link.url;
      btn.innerText = publication.link.title;
    });
  }
}

export default setPublicationLinks;
